import { render, staticRenderFns } from "./referencia.vue?vue&type=template&id=541c0e9b&scoped=true"
import script from "./referencia.vue?vue&type=script&lang=js"
export * from "./referencia.vue?vue&type=script&lang=js"
import style0 from "./referencia.vue?vue&type=style&index=0&id=541c0e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c0e9b",
  null
  
)

export default component.exports